module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "etapa-arrematantes",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading font-bold"
  }, [_vm._v("Editar Arrematante")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "panel-heading font-bold"
  }, [_vm._v("Dados Pessoais")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "1px solid #dee5e7"
    }
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('form', {
    staticClass: "bs-example form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-12 m-b-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Cpf")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Rg")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Orgão Emissor")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Data de Nascimento")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Apelido")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nacionalidade")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Estado Civil")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Sexo")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "panel-heading font-bold"
  }, [_vm._v("Dados necessários para aquisição de Imóveis (se casado)")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "1px solid #dee5e7"
    }
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('form', {
    staticClass: "bs-example form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nome Conjuge")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Rg Conjuge")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Cpf Conjuge")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "panel-heading font-bold"
  }, [_vm._v("Informações de Endereço")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "1px solid #dee5e7"
    }
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('form', {
    staticClass: "bs-example form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Cep")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Endereco")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Número")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Complemento")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Bairro")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Cidade")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("UF")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "sel1"
    }
  }, [_c('option', {
    attrs: {
      "selected": "selected"
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _c('option', [_vm._v("1")]), _vm._v(" "), _c('option', [_vm._v("2")]), _vm._v(" "), _c('option', [_vm._v("3")]), _vm._v(" "), _c('option', [_vm._v("4")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "panel-heading font-bold"
  }, [_vm._v("Informações de Contato")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "1px solid #dee5e7"
    }
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('form', {
    staticClass: "bs-example form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Celular")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Telefone")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Telefone Comercial")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "panel-heading font-bold"
  }, [_vm._v("Análise do Cadastro")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "1px solid #dee5e7"
    }
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('form', {
    staticClass: "bs-example form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Há alguma pendência no cliente ?")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "sel1"
    }
  }, [_c('option', {
    attrs: {
      "selected": "selected"
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _c('option', [_vm._v("1")]), _vm._v(" "), _c('option', [_vm._v("2")]), _vm._v(" "), _c('option', [_vm._v("3")]), _vm._v(" "), _c('option', [_vm._v("4")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Os documentos do cliente esta conferido ?")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "sel1"
    }
  }, [_c('option', {
    attrs: {
      "selected": "selected"
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _c('option', [_vm._v("1")]), _vm._v(" "), _c('option', [_vm._v("2")]), _vm._v(" "), _c('option', [_vm._v("3")]), _vm._v(" "), _c('option', [_vm._v("4")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("O cliente esta Apto a participar do leilão ?")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "sel1"
    }
  }, [_c('option', {
    attrs: {
      "selected": "selected"
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _c('option', [_vm._v("1")]), _vm._v(" "), _c('option', [_vm._v("2")]), _vm._v(" "), _c('option', [_vm._v("3")]), _vm._v(" "), _c('option', [_vm._v("4")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 m-t-md"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticClass: "i-checks"
  }, [_c('input', {
    attrs: {
      "id": "",
      "type": "checkbox",
      "value": ""
    }
  }), _c('i'), _vm._v(" "), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Leilões de Veículos")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 m-t-md"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticClass: "i-checks"
  }, [_c('input', {
    attrs: {
      "id": "",
      "type": "checkbox",
      "value": ""
    }
  }), _c('i'), _vm._v(" "), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Leilões de Imóveis")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 m-t-md"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticClass: "i-checks"
  }, [_c('input', {
    attrs: {
      "id": "",
      "type": "checkbox",
      "value": ""
    }
  }), _c('i'), _vm._v(" "), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Leilões de Materiais")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "panel-heading font-bold"
  }, [_vm._v("Observações do cadastro")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "1px solid #dee5e7"
    }
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('form', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Observação")]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "id": "",
      "placeholder": "",
      "rows": "5"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('button', {
    staticClass: "btn m-b-xs w-xs btn-info m-r-xs"
  }, [_vm._v("Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn m-b-xs w-xs btn-danger m-r-xs"
  }, [_vm._v("Negativar")]), _vm._v(" "), _c('button', {
    staticClass: "btn m-b-xs w-xs btn-default"
  }, [_vm._v("Cancelar")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "etapa-comitente",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading font-bold"
  }, [_vm._v("Editar Comitente")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "panel-heading font-bold"
  }, [_vm._v("Dados Comitente")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "1px solid #dee5e7"
    }
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('form', {
    staticClass: "bs-example form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Tipo de Pessoa")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Tipo de Comitente")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": ""
    }
  }, [_c('option', {
    attrs: {
      "selected": "selected"
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _c('option', [_vm._v("1")]), _vm._v(" "), _c('option', [_vm._v("2")]), _vm._v(" "), _c('option', [_vm._v("3")]), _vm._v(" "), _c('option', [_vm._v("4")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Endereço")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Bairro")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Cidade")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Estado")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": ""
    }
  }, [_c('option', {
    attrs: {
      "selected": "selected"
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _c('option', [_vm._v("1")]), _vm._v(" "), _c('option', [_vm._v("2")]), _vm._v(" "), _c('option', [_vm._v("3")]), _vm._v(" "), _c('option', [_vm._v("4")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Cep")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Inscrição Estadual")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Código ( Sistema RM )")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Telefone Comercial")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Telefone Fax")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nome Fantasia")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Qual o prazo para entrega dos documentos ?")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-lg"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticClass: "i-checks"
  }, [_c('input', {
    attrs: {
      "id": "",
      "type": "checkbox",
      "value": ""
    }
  }), _c('i'), _vm._v(" "), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Logo do comitente ?")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Logo do Comitente")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Condições do Comitente para Veículos")]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "rows": "5"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Condições do Comitente para Materiais")]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "rows": "5"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Observação")]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "rows": "5"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('button', {
    staticClass: "btn m-b-xs w-xs btn-info m-r-xs"
  }, [_vm._v("Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn m-b-xs w-xs btn-default"
  }, [_vm._v("Cancelar")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "etapa-leilao",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading font-bold"
  }, [_vm._v("Editar Leilão")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "panel-heading font-bold"
  }, [_vm._v("Dados Leilão")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "1px solid #dee5e7"
    }
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('form', {
    staticClass: "bs-example form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Lote")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Publicar")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": ""
    }
  }, [_c('option', {
    attrs: {
      "selected": "selected"
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _c('option', [_vm._v("Sim")]), _vm._v(" "), _c('option', [_vm._v("Não")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Data de Abertura")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Horário de Abertura")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Data de Fechamento")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Horário de Fechamento")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Tempo do Pregão")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Logo Agenda")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Local do Leilão")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Leiloeiro")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": ""
    }
  }, [_c('option', {
    attrs: {
      "selected": "selected"
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _c('option', [_vm._v("Sim")]), _vm._v(" "), _c('option', [_vm._v("Não")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Classificação")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": ""
    }
  }, [_c('option', {
    attrs: {
      "selected": "selected"
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _c('option', [_vm._v("Sim")]), _vm._v(" "), _c('option', [_vm._v("Não")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Status do Leilão")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": ""
    }
  }, [_c('option', {
    attrs: {
      "selected": "selected"
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _c('option', [_vm._v("Sim")]), _vm._v(" "), _c('option', [_vm._v("Não")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Leilões Instânciao")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": ""
    }
  }, [_c('option', {
    attrs: {
      "selected": "selected"
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _c('option', [_vm._v("Sim")]), _vm._v(" "), _c('option', [_vm._v("Não")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Loteado")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": ""
    }
  }, [_c('option', {
    attrs: {
      "selected": "selected"
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _c('option', [_vm._v("Sim")]), _vm._v(" "), _c('option', [_vm._v("Não")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-md m-b-lg"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Leilão Interno")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-lg m-b-lg"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticClass: "i-checks i-checks-sm"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _c('i'), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Leilão Judicial")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-lg m-b-lg"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticClass: "i-checks i-checks-sm"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _c('i'), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Auto Fechamento")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-lg m-b-lg"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticClass: "i-checks i-checks-sm"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _c('i'), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Taxa de ISS e ICMS ?")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Taxa Icms")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Taxa Iss")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Cod. Interno (RML)")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 m-t-xs"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticClass: "i-checks i-checks-sm"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _c('i'), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Comissão")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Comissão")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Resumo Leilão")]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "id": "",
      "type": "",
      "rows": "5",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Informação de Visitação")]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "id": "",
      "type": "",
      "rows": "5",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Informação de Retirada")]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "id": "",
      "type": "",
      "rows": "5",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Observação")]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "id": "",
      "type": "",
      "rows": "5",
      "placeholder": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('button', {
    staticClass: "btn m-b-xs w-xs btn-info m-r-xs"
  }, [_vm._v("Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn m-b-xs w-xs btn-default"
  }, [_vm._v("Cancelar")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "etapa-contato",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading font-bold"
  }, [_vm._v("Editar Contatos")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "panel-heading font-bold"
  }, [_vm._v("Dados de Contatos")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "1px solid #dee5e7"
    }
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('form', {
    staticClass: "bs-example form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Telefone")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 m-t-lg"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticClass: "i-checks i-checks-sm"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _c('i'), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Auto Fechamento")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Mensagem")]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "id": "",
      "type": "",
      "rows": "5",
      "placeholder": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('button', {
    staticClass: "btn m-b-xs w-xs btn-info m-r-xs"
  }, [_vm._v("Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn m-b-xs w-md btn-info m-r-xs"
  }, [_vm._v("Responder Mensagem")]), _vm._v(" "), _c('button', {
    staticClass: "btn m-b-xs w-xs btn-default"
  }, [_vm._v("Cancelar")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "etapa-leiloeiro",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading font-bold"
  }, [_vm._v("Editar Leiloeiro")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "panel-heading font-bold"
  }, [_vm._v("Dados do Leiloeiro")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "1px solid #dee5e7"
    }
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('form', {
    staticClass: "bs-example form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Telefone")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Bairro")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Cidade")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Endereço")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Número")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Complemento")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Cep")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Fax")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('button', {
    staticClass: "btn m-b-xs w-xs btn-info m-r-xs"
  }, [_vm._v("Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn m-b-xs w-xs btn-default"
  }, [_vm._v("Cancelar")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "etapa-banner"
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "panel panel-default",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "panel-heading font-bold"
  }, [_vm._v("Editar Banner")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "panel-heading font-bold"
  }, [_vm._v("Dados do Banner")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "1px solid #dee5e7"
    }
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('form', {
    staticClass: "bs-example form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-10 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Ordem")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Este banner contém vídeo ?")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Data Exibição")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Horário Exibição")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("SituacaoId")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('button', {
    staticClass: "btn m-b-xs w-xs btn-info m-r-xs"
  }, [_vm._v("Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn m-b-xs w-xs btn-default"
  }, [_vm._v("Cancelar")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "etapa-documento"
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading font-bold"
  }, [_vm._v("Editar Documentos")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "panel-heading font-bold"
  }, [_vm._v("Dados de Documentos")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "1px solid #dee5e7"
    }
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('form', {
    staticClass: "bs-example form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nome do Arrematante")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 m-t-md"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticClass: "i-checks i-checks-sm"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _c('i'), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Termo")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Data do Leilão")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Placa")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Cpf")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Lote Número")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Tipo")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "",
      "type": "",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 m-t-md"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Observação")]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "id": "",
      "type": "",
      "rows": "5",
      "placeholder": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('button', {
    staticClass: "btn m-b-xs w-xs btn-info m-r-xs"
  }, [_vm._v("Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn m-b-xs w-xs btn-default"
  }, [_vm._v("Cancelar")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27b11378","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/utilitarios/components/Editar.vue
// module id = 1746
// module chunks = 18